<template><!-- 應用關聯Success Case -->
  <div v-if="application !== null">
    <h3>設定關聯Success Case</h3>
    <div class="h4 py-5">
      前台Application內頁最多顯示6筆，依建立時間新到舊自動排序；
      此處綁定的筆數若超過6筆，僅最新的6筆會顯示。
    </div>
    <!-- 搜尋並新增Success Case -->
    <div class="d-flex align-center pa-5 brand-100">
      <label for="storyTitleAdd"><h4 class="mr-5 flex-shrink-0">添加案例</h4></label>
      <div class="d-flex my-n2 flex-grow-1 align-center">
        <div class="where-to-buy-autocomplete flex-grow-1">
          <v-autocomplete
            id="storyTitleAdd"
            :items="storyOptions"
            v-model="tempStory"
            :search-input.sync="searchKeyword"
            :loading="isLoadingOptions"
            placeholder="輸入關鍵字搜尋案例標題"
            item-value="id"
            item-text="title"
            no-filter
            hide-no-data
            hide-details
            return-object
            clearable
            style="background: white;"
            outlined
            dense
          >
            <template v-slot:item="{ item }">
              <div class="py-1">
                <div>{{ item.title }}</div>
                <div class="h6 ink-02-medium--text" v-if="item.application_title">
                  {{ item.application_title }}
                </div>
              </div>
            </template>
          </v-autocomplete>
        </div>
        <div class="ml-5">
          <button
            v-if="tempStory"
            class="btn btn-primary w-90px ml-5"
            @click="addStory">
            新增
          </button>
          <button v-else class="btn btn-primary w-90px ml-5" disabled>
            新增
          </button>
        </div>
      </div>
    </div>

    <!-- 已綁定的Success Case清單 -->
    <div class="form-item mt-5">
      <div
        v-if="!application.success_cases || application.success_cases.length === 0"
        class="h5 ink-02-medium--text py-5">
        尚未綁定任何Success Case
      </div>
      <div
        v-for="(story, i) in application.success_cases"
        :key="story.id"
        class="d-flex align-center justify-space-between py-3">
        <div class="h5 ink-01-emphasis--text">
          {{ story.title }}
        </div>
        <button class="btn square" @click="deleteStory(i)">
          <v-icon>delete</v-icon>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';

export default {
  data: () => ({
    storyOptions: [],
    tempStory: null,
    searchKeyword: '',
    isLoadingOptions: false,
    searchTimer: null,
  }),
  computed: {
    ...mapState('application', ['application']),
  },
  watch: {
    searchKeyword(keyword) {
      clearTimeout(this.searchTimer);
      if (!keyword) {
        this.storyOptions = [];
        return;
      }
      this.searchTimer = setTimeout(() => {
        this.isLoadingOptions = true;
        this.allStories(keyword)
          .then((result) => {
            this.storyOptions = result.data || result;
          })
          .finally(() => {
            this.isLoadingOptions = false;
          });
      }, 300);
    },
  },
  created() {
    if (!this.application.success_cases) {
      this.$set(this.application, 'success_cases', []);
    }
  },
  methods: {
    ...mapActions('story', ['allStories']),
    addStory() {
      const hasStory = this.application.success_cases
        .find((story) => story.id === this.tempStory.id);
      if (hasStory) {
        this.tempStory = null;
        return;
      }
      // 統一欄位格式 (與後端已綁定清單回傳格式一致: title/summary/cover_image)
      this.application.success_cases.push({
        id: this.tempStory.id,
        title: this.tempStory.title,
        summary: this.tempStory.summary,
      });
      this.tempStory = null;
      this.searchKeyword = '';
      this.storyOptions = [];
    },
    deleteStory(i) {
      this.application.success_cases.splice(i, 1);
    },
  },
};
</script>

<style lang="scss">
.where-to-buy-autocomplete {
  .v-autocomplete {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }

  // border
  fieldset {
    border-color: #d7dee7;
    background: white;
    border-radius: 8px;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }

  // placeholder color
  input::placeholder {
    color: #848fa0 !important;
    font-size: 16px;
    line-height: 1.43;
  }
}
</style>
